import { FormInput } from "../../components/form-input"
import Search from "../../../../assets/icons/search-alt.svg";
import { FormSelect } from "../../components/form-select";
import { useEffect, useState } from "react";
import { useFetch } from "../../../../hooks/useFetch";

import { Icon } from "../../../../components/icon";
import Add from "../../../../assets/icons/ico-add.svg";
import Remove from "../../../../assets/icons/excluir-ico.svg";
import Arrow from "../../../../assets/icons/arrow-right.svg";
import Loading from "../../../../assets/icons/loading.svg"

import {
    birthDateMask,
    cellMask,
    cepMask,
    cpfMask,
    letraMask,
    numberMask,
    phoneMask,
    rgMask,
} from "../../../../utils/masks";
import {
    birthDateValidator,
    cepValidator,
    cpfValidator,
    mailValidator,
    requiredSelectValidator,
    rgValidator,
    sizeValidator
} from "../../../../utils/validators";

export const Socios = ({ nextStep, prevStep }) => {
    const [isValid, setIsValid] = useState(true);

    const [socios, setSocios] = useState([]);


    const adicionarSocio = () => {
        let id = 0;
        if (socios.length > 0) id = socios[socios.length - 1].id + 1
        setSocios([...socios, { id: id }])
    }

    const removeSocio = (id) => {
        const ns = [...socios.filter(x=> x.id != id)]
        setSocios(ns)
    }

    const {data, isLoading, error} = useFetch(localStorage.getItem("idEmpresa") !=undefined && process.env.REACT_APP_API_URL+`Get_CompanyPartner?idEmpresa=${localStorage.getItem("idEmpresa")}`)
    useEffect(()=> {
        if(data!=undefined && data.hasError===false && data.model.length>0){     
            setIsValid(true);
            const sociosToAdd=[] 
            data.model.forEach(function (socio,index){
                sociosToAdd.push(
                    {id:index , nome:socio.nm_socio , participacao:socio.participacao , telefoneComercial:socio.nu_tel_comercial , naturalidade:socio.naturalidade , nacionalidade:socio.nacionalidade , estadoCivil:socio.estado_civil , 
                     emissorDocumento:socio.emissor_documento , email:socio.str_email , dtNascimento:socio.dt_nascimento, dtEmissaoDocumento:socio.dt_emissao_documento , documento:socio.documento , cpf:socio.cd_cpf , 
                     celular:socio.nu_celular , cargo:socio.cargo , bairro:socio.bairro , cep:socio.cd_cep , cidade:socio.cidade , complemento:socio.complemento , endereco:socio.endereco , estado:socio.estado , 
                     numero:socio.numero , 
                    },
                )
            });
            setSocios(sociosToAdd)
        }
    }, [data, error])

    const onChange = (socioId, value, key) => {
        const socio = socios.find(x=> x.id == socioId)
        socio[key] = value
        const sociosCopia=[...socios]
        sociosCopia[socios.findIndex(socio=>socio.id==socioId)]={...socio}
        setSocios(sociosCopia)
    }
    const updateField = (field, state) => {
        setInputState(prevState => {
            const updatedState = { ...prevState, [field]: state };
            return updatedState;
        });
    };


    const [inputState, setInputState] = useState({});


    useEffect(() => {
        let isAllValid = true;
        for (const v of Object.values(inputState)) {
            if (v === false) {
                isAllValid = false;
                break;
            }
        }
        setIsValid(isAllValid);
    }, [inputState]);


    const [loadingSend, setLoadingSend] = useState(false)

    const onSubmit = async (e) => {
        e.preventDefault();
        if(isValid){
            if (socios.length === 0) {
                setIsValid(false);
                return;
            }

            registerPartnerData(e.target)
        }
    }

    const [apiError, setApiError] = useState("")
    function registerPartnerData(form){
        setLoadingSend(true);
        var data = []
        socios.forEach(socio => {
            
            data.push(
                {   
                    "nm_socio": form[`nomesocio${socio.id}`].value,
                    "participacao": form[`participacao${socio.id}`].value,
                    "cargo": form[`cargo${socio.id}`].value,
                    "dt_nascimento": form[`nascimento${socio.id}`].value,
                    "estado_civil": form[`estadocivil${socio.id}`].value,
                    "nacionalidade": form[`nacionalidade${socio.id}`].value,
                    "naturalidade": form[`naturalidade${socio.id}`].value,
                    "cd_cpf": form[`cpf${socio.id}`].value.replace("-", "").replace(".", "").replace("/", ""),
                    "documento": form[`documentoidentificacao${socio.id}`].value,
                    "dt_emissao_documento": form[`emissao${socio.id}`].value,
                    "emissor_documento": form[`emissor${socio.id}`].value,
                    "nu_tel_comercial": form[`telefonecomercial${socio.id}`].value,
                    "nu_celular": form[`celular${socio.id}`].value,
                    "str_email": form[`email${socio.id}`].value,
                    "cd_cep": form[`cep${socio.id}`].value,
                    "endereco": form[`endereco${socio.id}`].value,
                    "numero": form[`numero${socio.id}`].value,
                    "complemento": form[`complemento${socio.id}`].value,
                    "bairro": form[`bairro${socio.id}`].value,
                    "estado": form[`estado${socio.id}`].value,
                    "cidade": form[`cidade${socio.id}`].value,
                  }
            )   }

        );

        fetch(process.env.REACT_APP_API_URL+`Register_CompanyPartner?id_empresa=${localStorage.getItem("idEmpresa")}`,
            {
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json'
                },
                method: "POST",
                body: JSON.stringify(data),
            })
            .then((response)=>{ 
                response.json().then((json)=>{
                    if(json.hasError===false) {
                        nextStep();
                    }else{
                        setApiError(json.description)
                        setTimeout(() => {setApiError("")}, 1500)
                    }
                    })
            }).finally(()=>{setLoadingSend(false);})
        
    }

    return (
        <form className='conta-content' onSubmit={onSubmit}>

            <div className='conta-content-section'>
                <h2 className="conta-section-title">Sócios</h2>

                {socios.map((socio, key) => {
                    return (

                        <div className="form-section">
                            <div className="socio-heading">
                                <span className="socio-id">{key + 1}</span>
                                <span className="text-icon" onClick={() => { removeSocio(socio.id) }}>
                                    <Icon icon={Remove} />
                                    Excluir
                                </span>
                            </div>
                            <div className="form-section-row">
                                <FormInput id={`nomesocio${socio.id}`} label={"Nome do sócio"}
                                onChange={(e) => {onChange(socio.id, e.target.value, 'nome')}} value={socio.nome}
                                    validators={[
                                        { func: sizeValidator, argument: 1 }
                                    ]}
                                    mask={
                                        letraMask
                                    }
                                    updateField={updateField}
                                />
                                <FormInput sufix="%" id={`participacao${socio.id}`} label={"Participação"} type="number"
                                onChange={(e) => {onChange(socio.id, e.target.value, 'participacao')}} value={socio.participacao}
                                    validators={[
                                        { func: sizeValidator, argument: 1 }
                                    ]}
                                    updateField={updateField}

                                />
                                {/* <FormInput id={`dataentrada${socio.id}`} label={"Nome do sócio"} type="date"
                                    validators={[
                                        { func: sizeValidator, argument: 1 }
                                    ]}
                                    updateField={updateField}
                                /> */}
                                <FormInput id={`cargo${socio.id}`} label={"Cargo"}
                                onChange={(e) => {onChange(socio.id, e.target.value, 'cargo')}} value={socio.cargo}
                                    validators={[
                                        { func: sizeValidator, argument: 1 }
                                    ]}
                                    updateField={updateField}
                                />
                            </div>
                            <div className="form-section-row">
                                <FormInput id={`nascimento${socio.id}`} label={"Nascimento"} type="date"
                                onChange={(e) => {onChange(socio.id, e.target.value, 'dtNascimento')}} value={socio.dtNascimento}
                                    validators={[
                                        { func: sizeValidator, argument: 1 }
                                    ]}
                                    updateField={updateField}
                                />
                                <FormSelect id={`estadocivil${socio.id}`} label={"Estado Civil"}
                                    defaultValue=""
                                    updateField={updateField}
                                    validators={[
                                        {func:requiredSelectValidator}
                                    ]}
                                >
                                    <option> Solteiro/a </option>
                                    <option> Casado/a </option>
                                    <option> Viuvo/a </option>
                                    <option> Divorciado/a </option>
                                    <option> Separado/a Judicialmente</option>

                                </FormSelect>
                                <FormInput id={`nacionalidade${socio.id}`} label={"Nacionalidade"}
                                onChange={(e) => {onChange(socio.id, e.target.value, 'nacionalidade')}} value={socio.nacionalidade}
                                    validators={[
                                        { func: sizeValidator, argument: 1 }
                                    ]}
                                    mask={
                                        letraMask
                                    }
                                    updateField={updateField}
                                />
                                <FormInput id={`naturalidade${socio.id}`} label={"Naturalidade"}
                                onChange={(e) => {onChange(socio.id, e.target.value, 'naturalidade')}} value={socio.naturalidade}
                                    validators={[
                                        { func: sizeValidator, argument: 1 }
                                    ]}
                                    mask={
                                        letraMask
                                    }
                                    updateField={updateField}
                                />
                            </div>
                            <div className="form-section-row">
                                <FormInput id={`cpf${socio.id}`} label={"CPF"}
                                onChange={(e) => {onChange(socio.id, e.target.value, 'cpf')}} value={socio.cpf}
                                    validators={[
                                        { func: cpfValidator, argument: 11 }
                                    ]}
                                    mask={
                                        cpfMask
                                    }
                                    updateField={updateField}
                                />
                                <FormInput id={`documentoidentificacao${socio.id}`} label={"Documento de indentificação"}
                                onChange={(e) => {onChange(socio.id, e.target.value, 'documento')}} value={socio.documento}
                                    validators={[
                                        { func: rgValidator, argument: 9 }
                                    ]}
                                    mask={
                                        rgMask
                                    }
                                    updateField={updateField}
                                />
                                <FormInput id={`emissao${socio.id}`} label={"Emissão"} type="date"
                                onChange={(e) => {onChange(socio.id, e.target.value, 'dtEmissaoDocumento')}} value={socio.dtEmissaoDocumento}
                                    validators={[
                                        { func: sizeValidator, argument: 1 }
                                    ]}
                                    updateField={updateField}
                                />
                                <FormSelect id={`emissor${socio.id}`} label={"Emissor"}
                                    defaultValue=""
                                    updateField={updateField}
                                    validators={[
                                        {func:requiredSelectValidator}
                                    ]}
                                >
                                    <option value="SSP"> SSP </option>
                                    <option value="DETRAN"> DETRAN </option>
                                    <option value="IFP"> IFP </option>
                                    <option value="MTE"> MTE </option>
                                    <option value="DPF"> DPF </option>
                                    <option value="RF"> Receita Federal </option>
                                </FormSelect>
                            </div>
                            <div className="form-section-row">
                                <FormInput id={`telefonecomercial${socio.id}`} label={"Telefone Comercial"}
                                onChange={(e) => {onChange(socio.id, e.target.value, 'telefoneComercial')}}
                                value={socio.telefoneComercial}
                                    validators={[
                                        { func: sizeValidator, argument: 10 }
                                    ]}
                                    mask={
                                        phoneMask
                                    }
                                    placeholder="(XX) XXXX-XXXX"
                                    updateField={updateField}
                                />
                                <FormInput id={`celular${socio.id}`} label={"Celular"}
                                onChange={(e) => {onChange(socio.id, e.target.value, 'celular')}}
                                value={socio.celular}
                                    validators={[
                                        { func: sizeValidator, argument: 11 }
                                    ]}
                                    mask={
                                        cellMask
                                    }
                                    placeholder="(XX) XXXXX-XXXX"
                                    updateField={updateField}
                                />
                                <FormInput id={`email${socio.id}`} label={"E-mail"}
                                value={socio.email}
                                onChange={(e) => {onChange(socio.id, e.target.value, 'email')}}
                                    validators={[
                                        { func: mailValidator, argument: 1 }
                                    ]}
                                    updateField={updateField}
                                />
                            </div>
                            <div className="form-section-row">
                                <FormInput id={`cep${socio.id}`} label={"CEP"} colStyle={{ minWidth: '100px' }} endIcon={Search}
                                onChange={(e) => {onChange(socio.id, e.target.value, 'cep')}}
                                value={socio.cep}
                                    validators={[
                                        { func: cepValidator, argument: 8 }
                                    ]}
                                    mask={
                                        cepMask
                                    }
                                    updateField={updateField}
                                />
                                <FormInput id={`endereco${socio.id}`} label={"Endereço"} colStyle={{ minWidth: '120px', flexBasis: "12.5%" }}
                                    onChange={(e) => {onChange(socio.id, e.target.value, 'endereco')}}  value={socio.endereco}
                                    validators={[
                                        { func: sizeValidator, argument: 1 }
                                    ]}
                                    updateField={updateField}
                                />
                                <FormInput id={`numero${socio.id}`} label={"Nº"} colStyle={{ minWidth: '50px' }}
                                onChange={(e) => {onChange(socio.id, e.target.value, 'numero')}} value={socio.numero}
                                    validators={[
                                        { func: sizeValidator, argument: 1 }
                                    ]}
                                    mask={
                                        numberMask
                                    }
                                    updateField={updateField}
                                />
                                <FormInput id={`complemento${socio.id}`} label={"Complemento"} colStyle={{ minWidth: '100px', flexBasis: "8%" }} 
                                onChange={(e) => {onChange(socio.id, e.target.value, 'complemento')}} value={socio.complemento}/>
                                <FormInput id={`bairro${socio.id}`} label={"Bairro"} colStyle={{ minWidth: '100px', flexBasis: "8%" }}
                                onChange={(e) => {onChange(socio.id, e.target.value, 'bairro')}} value={socio.bairro}
                                    validators={[
                                        { func: sizeValidator, argument: 1 }
                                    ]}
                                    updateField={updateField}
                                />
                                <FormInput id={`cidade${socio.id}`} onChange={(e) => {onChange(socio.id, e.target.value, 'cidade')}} value={socio.cidade}
                                 label={"Cidade"} colStyle={{ minWidth: '100px', flexBasis: "8%" }}
                                    validators={[
                                        { func: sizeValidator, argument: 1 }
                                    ]}
                                    updateField={updateField}
                                />
                                <FormSelect id={`estado${socio.id}`} label={"Estado"} colStyle={{ minWidth: '55px' }}
                                    defaultValue=""
                                    updateField={updateField}
                                    validators={[
                                        {func:requiredSelectValidator}
                                    ]}
                                >
                                    <option> Acre </option>
                                    <option> Alagoas </option>
                                    <option> Amapá </option>
                                    <option> Amazonas </option>
                                    <option> Bahia </option>
                                    <option> Ceará </option>
                                    <option> Espirito Santo </option>
                                    <option> Goiás </option>
                                    <option> Maranhão </option>
                                    <option> Mato Grosso </option>
                                    <option> Mato Grosso do Sul</option>
                                    <option> Minas Gerais </option>
                                    <option> Pará </option>
                                    <option> Paraíba </option>
                                    <option> Paraná </option>
                                    <option> Pernambuco </option>
                                    <option> Piauí </option>
                                    <option> Rio de Janeiro </option>
                                    <option> Rio Grande do Norte </option>
                                    <option> Rio Grande do Sul </option>
                                    <option> Rondônia </option>
                                    <option> Roraima </option>
                                    <option> Santa Catarina </option>
                                    <option> São Paulo </option>
                                    <option> Sergipe </option>
                                    <option> Tocantins </option>
                                    <option> Distrito Federal </option>

                                </FormSelect>

                            </div>



                            <div className='divider' style={{ marginTop: "40px" }} />

                        </div>

                    )
                })}
                <span className="text-icon" onClick={() => { adicionarSocio() }} style={{ marginTop: "15px" }}>
                    <Icon icon={Add} />
                    Adicionar sócio
                </span>

                {!isValid && socios.length === 0 && (
                    <div className="error-message">
                        <span>Você precisa adicionar pelo menos um sócio.</span>
                    </div>
                )}
            </div>


            <div className='conta-content-footer'>
                <button type="button" disabled={loadingSend} className='step-button prev-step' onClick={() => { prevStep() }}>
                    <span className='icon'> <Icon icon={Arrow} size={18} rotation={180} /> </span>
                    <span className="text">Voltar</span>
                </button>
                <div className='divider'></div>
                <button type="submit" disabled={socios.length === 0 || !isValid || loadingSend} className='step-button next-step'>

                    <span className="text">Prosseguir</span>
                    <span className='icon'> <Icon icon={loadingSend ? Loading : Arrow} size={18} /> </span>
                   
                </button>
            </div>
            {apiError !== "" && <div style={{width:"100%", display:"flex", justifyContent:"end", marginTop:"10px"}}> 
                <span style={{color:"red"}}> {apiError} </span>
            </div>}

        </form>
    )
}
